import React, { useCallback } from 'react';

import { IconButton } from '@mui/material';
import { Eye } from 'lucide-react';
import { AlineTooltip } from 'src/components';
import { openLink } from 'src/helpers';

import { getTaskPreviewLink } from './task-review-helpers';

interface TaskPreviewButtonProps {
  task: { id: string; title: string };
}

/** Opens Preview as external in a new tab. */
export const TaskPreviewButton = React.memo(function TaskPreviewButton({
  task,
}: TaskPreviewButtonProps) {
  const openPreview = useCallback(
    () =>
      openLink(getTaskPreviewLink(task.id), {
        title: `Preview: ${task.title || 'Untitled task'}`,
      }),
    [task.id, task.title]
  );

  return (
    <AlineTooltip
      arrow
      placement="bottom"
      title="Preview as external. See this task as external reviewers do."
    >
      <IconButton aria-label="Preview as external" size="small" onClick={openPreview}>
        <Eye size={18} />
      </IconButton>
    </AlineTooltip>
  );
});
